module.exports = __webpack_public_path__ + "assets/retina_InteriorAnglesDetailed.ff0ebf56c6bf17a4fb5d7a2cd2e5cea1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_InteriorAnglesDetailed.png
// module id = 680
// module chunks = 0